export const RECALLS_BASE_ROUTE = 'recalls';
const RECALLS_BASE_PATH = `/${RECALLS_BASE_ROUTE}`;
export default RECALLS_BASE_PATH;
